import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Card from "../components/card"

const IndexPage = ({ pageContext }) => {
  return (
    <Layout>
      <SEO title="Home" />

      <section>
        <h1
          className="text-6xl font-semibold text-purple-700"
          style={{ lineHeight: "70px" }}
        >
          Featured
          <br /> <span className="text-stroke">Projects</span>
        </h1>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-10 xl:gap-24">
          {Object.values(pageContext).map(({ node }) => (
              <Card
                props={node.frontmatter}
              />
          ))}
        </div>
      </section>
    </Layout>
  )
}

export default IndexPage
